import React, { useState, useEffect, useMemo, useCallback } from 'react';
import ListaSATIFechada from '../Components/ListaSATIFechada/listaSATIFechada';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

import './SatiFechada.css';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../config/backend';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { fetchAnalistas } from '../../api/usuarios';

const SORT_FIELDS = { date: 'data', number: 'id', requester: 'solicitante', technician: 'atendente', type: 'tipo' };

function SatiFechada() {
    const history = useHistory();
    const user = localStorage.getItem('codUsu');

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalSearch, setGlobalSearch] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [sortBy, setSortBy] = useState('date');
    const [sortOrder, setSortOrder] = useState('desc');
    const [technicianMap, setTechnicianMap] = useState({});

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    }, [history]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            verificandoToken();
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/satis/fechadas', {
                headers: { Authorization: `${token}` },
                params: { user, descr: ' ', colab: '', satNum: '' }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            const listaSATI = raw.map((item) => ({
                id: item.id,
                descricao: (item.descricao ?? '').toString(),
                data: item.data,
                atendente: (item.atendente ?? '').toString(),
                solicitante: (item.solicitante ?? '').toString(),
                tipo: item.SATTIP ?? item.tipo
            }));
            setData(listaSATI);
        } catch (error) {
            if (error?.response?.status !== 404) console.error('Erro ao buscar dados:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        verificar();
        fetchData();
    }, [verificar, fetchData]);

    useEffect(() => {
        fetchAnalistas().then((list) => {
            const map = {};
            (list || []).forEach((u) => {
                const id = u.USUSEQ ?? u.ususeq ?? u.id;
                const nome = u.USRNOMCPL ?? u.usrnomcpl ?? u.nome;
                if (id != null && nome) map[String(id)] = nome;
            });
            setTechnicianMap(map);
        }).catch(() => {});
    }, []);

    const setQuickDateRange = useCallback((preset) => {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        const from = new Date(today);
        from.setHours(0, 0, 0, 0);
        if (preset === 'hoje') {
            setDateFrom(from.toISOString().slice(0, 10));
            setDateTo(today.toISOString().slice(0, 10));
        } else if (preset === '7') {
            from.setDate(from.getDate() - 6);
            setDateFrom(from.toISOString().slice(0, 10));
            setDateTo(today.toISOString().slice(0, 10));
        } else if (preset === '30') {
            from.setDate(from.getDate() - 29);
            setDateFrom(from.toISOString().slice(0, 10));
            setDateTo(today.toISOString().slice(0, 10));
        }
    }, []);

    const filteredAndSortedData = useMemo(() => {
        let list = data;
        const q = (globalSearch || '').toString().trim().toLowerCase();
        if (q) {
            list = list.filter((sati) => {
                const idStr = String(sati.id ?? '');
                const desc = (sati.descricao ?? '').toLowerCase();
                const sol = (sati.solicitante ?? '').toLowerCase();
                const atd = (sati.atendente ?? '').toLowerCase();
                return idStr.toLowerCase().includes(q) || desc.includes(q) || sol.includes(q) || atd.includes(q);
            });
        }
        if (dateFrom) {
            const from = new Date(dateFrom);
            from.setHours(0, 0, 0, 0);
            list = list.filter((sati) => new Date(sati.data) >= from);
        }
        if (dateTo) {
            const to = new Date(dateTo);
            to.setHours(23, 59, 59, 999);
            list = list.filter((sati) => new Date(sati.data) <= to);
        }
        const field = SORT_FIELDS[sortBy] || 'data';
        const dir = sortOrder === 'asc' ? 1 : -1;
        return [...list].sort((a, b) => {
            let va = a[field];
            let vb = b[field];
            if (field === 'data') {
                va = new Date(va).getTime();
                vb = new Date(vb).getTime();
            } else if (field === 'id') {
                va = Number(va) || 0;
                vb = Number(vb) || 0;
            } else {
                va = (va ?? '').toString().toLowerCase();
                vb = (vb ?? '').toString().toLowerCase();
            }
            if (va < vb) return -dir;
            if (va > vb) return dir;
            return 0;
        });
    }, [data, globalSearch, dateFrom, dateTo, sortBy, sortOrder]);

    const handleSort = useCallback((field) => {
        setSortBy((prev) => {
            if (prev === field) {
                setSortOrder((o) => (o === 'asc' ? 'desc' : 'asc'));
                return prev;
            }
            setSortOrder((field === 'date' || field === 'number') ? 'desc' : 'asc');
            return field;
        });
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo sati-fechada-page">
                    <header className="sati-fechada-header">
                        <h1 className="sati-fechada-title">Histórico de chamados encerrados</h1>
                        <p className="sati-fechada-subtitle">Consulta e pesquisa no arquivo de atendimentos.</p>
                    </header>

                    <div className="sati-fechada-toolbar">
                        <div className="sati-fechada-search">
                            <i className="fas fa-search sati-fechada-search-icon" aria-hidden="true" />
                            <input
                                type="text"
                                className="form-control sati-fechada-search-input"
                                placeholder="Buscar por número, descrição, solicitante ou atendente..."
                                value={globalSearch}
                                onChange={(e) => setGlobalSearch(e.target.value)}
                                aria-label="Busca global"
                            />
                        </div>
                        <div className="sati-fechada-dates">
                            <div className="sati-fechada-quick-dates">
                                <button type="button" className="btn btn-sm btn-outline-secondary sati-fechada-quick-btn" onClick={() => setQuickDateRange('hoje')}>Hoje</button>
                                <button type="button" className="btn btn-sm btn-outline-secondary sati-fechada-quick-btn" onClick={() => setQuickDateRange('7')}>7 dias</button>
                                <button type="button" className="btn btn-sm btn-outline-secondary sati-fechada-quick-btn" onClick={() => setQuickDateRange('30')}>30 dias</button>
                            </div>
                            <label className="sati-fechada-date-label">
                                <span>De</span>
                                <input type="date" className="form-control form-control-sm" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} aria-label="Data inicial" />
                            </label>
                            <label className="sati-fechada-date-label">
                                <span>Até</span>
                                <input type="date" className="form-control form-control-sm" value={dateTo} onChange={(e) => setDateTo(e.target.value)} aria-label="Data final" />
                            </label>
                        </div>
                        <button type="button" className="btn btn-secondary sati-fechada-btn-refresh" onClick={fetchData} disabled={loading} title="Atualizar lista">
                            <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`} /> {loading ? 'Carregando...' : 'Atualizar'}
                        </button>
                    </div>

                    <div className="sati-fechada-table-wrap">
                        <ListaSATIFechada
                            arraySATI={filteredAndSortedData}
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            onSort={handleSort}
                            technicianMap={technicianMap}
                            hasFilters={!!(globalSearch.trim() || dateFrom || dateTo)}
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}

export default SatiFechada;
